export const BRAND = {
  name: "MD Supply Wellness",
  shortName: "MD Supply",
  tagline: "Bethesda's premium medical & wellness dispensary",
  phone: "(301) 348-1300",
  phoneRaw: "+13013481300",
  email: "info@mdsupplywellness.com",
  careersEmail: "info@mdsupplywellness.com",
  address: {
    line1: "4713 Maple Ave",
    line2: "Bethesda, MD 20814",
  },
  hours: [
    { day: "Monday – Thursday", time: "8:00 AM – 10:00 PM" },
    { day: "Friday – Saturday", time: "8:00 AM – 11:00 PM" },
    { day: "Sunday", time: "9:00 AM – 9:00 PM" },
  ],
  mapsLink:
    "https://www.google.com/maps/place/MD+Supply+Wellness/data=!4m2!3m1!1s0x0:0x355fff25bde6a0aa",
  mapEmbed:
    "https://www.google.com/maps?q=4713+Maple+Ave,+Bethesda,+MD+20814&output=embed",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_eae10ffc-1940-429a-9e19-9bc97af3ae22/artifacts/9ao05bxz_1c208d1a-ac53-4125-90f5-1c3bd7ff7f83-e45316db.jpeg",
  logoTransparent: "/logo.png",
};

export const IMAGES = {
  heroAbstract:
    "https://images.unsplash.com/photo-1708778002586-37c4f23b7f3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGRhcmslMjB0ZWFsJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzgwMTYyNTd8MA&ixlib=rb-4.1.0&q=85",
  macro1:
    "https://images.unsplash.com/photo-1634902325861-7bd370ae02a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxjYW5uYWJpcyUyMGZsb3dlciUyMG1hY3JvfGVufDB8fHx8MTc3ODAxNjI1MXww&ixlib=rb-4.1.0&q=85",
  macro2:
    "https://images.unsplash.com/photo-1634902349007-cfc9c61dff79?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interior:
    "https://images.unsplash.com/photo-1775210727551-42bc213b2c44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwaGFybWFjeSUyMGludGVyaW9yfGVufDB8fHx8MTc3ODAxNjI1N3ww&ixlib=rb-4.1.0&q=85",
  lifestyle:
    "https://images.unsplash.com/photo-1525005712886-ca67585e2206?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxhcG90aGVjYXJ5JTIwd2VsbG5lc3N8ZW58MHx8fHwxNzc4MDE2MjUxfDA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Menu", to: "/menu" },
  {
    label: "Visit",
    children: [
      {
        label: "Locations",
        to: "/locations",
        desc: "Our Bethesda flagship on Maple Ave",
      },
      {
        label: "Areas Served",
        to: "/areas-served",
        desc: "ZIP codes we deliver to across MD & DC",
      },
    ],
  },
  {
    label: "Learn",
    children: [
      {
        label: "Education",
        to: "/education",
        desc: "Cannabis basics, dosing, terpenes",
      },
      {
        label: "Blog",
        to: "/blog",
        desc: "Latest articles from our Bethesda team",
      },
      {
        label: "FAQ",
        to: "/faq",
        desc: "Answers to the questions we hear most",
      },
    ],
  },
  {
    label: "Company",
    children: [
      { label: "About", to: "/about", desc: "Our mission and values" },
      {
        label: "Careers",
        to: "/careers",
        desc: "Open roles — apply in minutes",
      },
    ],
  },
  { label: "Contact", to: "/contact" },
];

export const JOBS = [
  {
    slug: "compliance-manager",
    title: "Compliance Manager",
    type: "Full-Time",
    bullets: [
      "Own Maryland MCA compliance across daily operations, audits, and reporting.",
      "Maintain SOPs, training logs, and inventory-tracking accuracy in state systems.",
      "Partner with leadership on inspections, incident reporting, and continual improvement.",
    ],
  },
  {
    slug: "am-supervisor",
    title: "AM Supervisor",
    type: "Full-Time",
    bullets: [
      "Lead the morning shift — team check-ins, floor set-up, and opening procedures.",
      "Coach budtenders and reception staff on service, compliance, and product knowledge.",
      "Drive a calm, welcoming customer experience through the AM rush.",
    ],
  },
  {
    slug: "pm-supervisor",
    title: "PM Supervisor",
    type: "Full-Time",
    bullets: [
      "Own the evening shift — closing procedures, cash reconciliation, and end-of-day reporting.",
      "Mentor the PM team and keep service quality strong through peak hours.",
      "Coordinate with the AM Supervisor on daily handoffs and continuity.",
    ],
  },
  {
    slug: "budtender",
    title: "Budtender",
    type: "FT & PT",
    bullets: [
      "Guide each guest with thoughtful, education-first product recommendations — never pushy.",
      "Help patients and adult-use shoppers understand effects, responsible dosing, and terpene differences.",
      "Keep every sale Maryland-compliant: verify ID, respect purchase limits, and maintain clean POS records.",
    ],
  },
];

export const DELIVERY_ZONES = [
  {
    city: "Bethesda",
    slug: "bethesda",
    zips: ["20814", "20815", "20816", "20817"],
    note: "Flagship service area",
    neighborhoods: [
      "Downtown Bethesda",
      "Bethesda Row",
      "Woodmont Triangle",
      "Battery Park",
      "Edgemoor",
      "Wyngate",
    ],
    landmarks: ["Bethesda Metro", "NIH", "Walter Reed", "Wildwood Shopping Center"],
  },
  {
    city: "Chevy Chase",
    slug: "chevy-chase",
    zips: ["20815", "20825"],
    neighborhoods: ["Chevy Chase Village", "Somerset", "Martin's Additions", "Section Three"],
    landmarks: ["Friendship Heights Metro", "The Collection at Chevy Chase"],
  },
  {
    city: "Rockville",
    slug: "rockville",
    zips: ["20850", "20852", "20853"],
    neighborhoods: ["Rockville Town Center", "King Farm", "Twinbrook", "Fallsmead"],
    landmarks: ["Rockville Metro", "Rockville Town Square", "Montgomery College"],
  },
  {
    city: "Potomac",
    slug: "potomac",
    zips: ["20854"],
    neighborhoods: ["Potomac Village", "Avenel", "River Falls", "Falls Road"],
    landmarks: ["Potomac Village", "TPC Potomac", "C&O Canal"],
  },
  {
    city: "Kensington",
    slug: "kensington",
    zips: ["20895"],
    neighborhoods: ["Old Town Kensington", "Rock Creek Hills", "Kensington Estates"],
    landmarks: ["Kensington MARC Station", "Antique Row", "Rock Creek Park"],
  },
  {
    city: "Silver Spring",
    slug: "silver-spring",
    zips: ["20910", "20901"],
    neighborhoods: ["Downtown Silver Spring", "Woodside", "Sligo Park Hills", "Forest Glen"],
    landmarks: ["Silver Spring Metro", "The Fillmore", "AFI Silver"],
  },
  {
    city: "North Bethesda",
    slug: "north-bethesda",
    zips: ["20852"],
    neighborhoods: ["Pike & Rose", "White Flint", "Grosvenor", "Randolph Hills"],
    landmarks: ["Pike & Rose", "White Flint Metro", "Strathmore"],
  },
  {
    city: "Washington D.C.",
    slug: "washington-dc",
    zips: ["20015", "20016"],
    neighborhoods: ["Chevy Chase DC", "Friendship Heights", "Tenleytown", "American University Park"],
    landmarks: ["Tenleytown-AU Metro", "Friendship Heights Metro", "Rock Creek Park"],
  },
];

export const EDUCATION_TOPICS = [
  {
    title: "Cannabis Basics",
    summary:
      "Understand the difference between cannabinoids like THC and CBD, and how each interacts with your endocannabinoid system.",
    tag: "Foundations",
  },
  {
    title: "Consumption Methods",
    summary:
      "Flower, vape, edibles, tinctures, topicals — each method has a different onset, duration, and intensity profile.",
    tag: "Methods",
  },
  {
    title: "Maryland Medical Program",
    summary:
      "How to qualify as a Maryland medical cannabis patient, condition list, and what to bring to your first visit.",
    tag: "Program",
  },
  {
    title: "Dosing Responsibly",
    summary:
      "Start low, go slow. Guidance on microdosing, tolerance breaks, and finding a dose that supports your wellness goals.",
    tag: "Dosing",
  },
  {
    title: "Terpenes & Effects",
    summary:
      "Myrcene, limonene, pinene and beyond — the aromatic compounds that shape a strain's character and experience.",
    tag: "Science",
  },
  {
    title: "Safe Storage & Travel",
    summary:
      "Best practices for keeping your cannabis fresh, potent, and secure — plus Maryland possession and transport laws.",
    tag: "Compliance",
  },
];

export const FAQS = [
  {
    q: "Is MD Supply Wellness open yet?",
    a: "We are preparing to open soon in Bethesda, Maryland. Join the waitlist to be the first to know our official launch date and to receive early-access offers.",
  },
  {
    q: "Do I need a Maryland medical card to shop?",
    a: "Maryland allows both medical patients and qualifying adult-use customers to purchase cannabis from licensed dispensaries. All customers must be 21+ or a registered medical patient and present valid ID at checkout.",
  },
  {
    q: "What areas do you deliver to?",
    a: "Our delivery footprint is centered on Bethesda (20814) and expands throughout Montgomery County — including Chevy Chase, Rockville, Potomac, Kensington, Silver Spring, and select DC ZIP codes. Visit our Delivery Areas page for the full list.",
  },
  {
    q: "What forms of payment will you accept?",
    a: "At launch we plan to accept cash and debit (with PIN). Payment methods are subject to Maryland regulatory guidance and may evolve.",
  },
  {
    q: "How are your products tested?",
    a: "Every product on our menu will be sourced from Maryland-licensed cultivators and processors, and will carry full lab testing for potency, pesticides, heavy metals, and microbials — fully compliant with state standards.",
  },
  {
    q: "Can I consume cannabis on-site?",
    a: "No. On-site consumption is not permitted at Maryland dispensaries. All products must be sealed when leaving the store and transported responsibly.",
  },
  {
    q: "How do I apply for a job?",
    a: "We're hiring ahead of launch. Email your resume and a short note to careers@mdsupplywellness.com referencing the role you're interested in. See our Shop page for current openings.",
  },
  {
    q: "Do you work with patients new to cannabis?",
    a: "Absolutely. Our team is trained to guide first-time and experienced customers alike — starting low, going slow, and matching you with products that fit your wellness goals.",
  },
];

export const CORE_PILLARS = [
  {
    title: "Medical-Grade Quality",
    body:
      "Every product sourced from Maryland-licensed growers with full panel lab testing — potency, contaminants, terpene profile.",
    icon: "shield",
  },
  {
    title: "Bethesda-Rooted",
    body:
      "Proudly serving the Bethesda, Chevy Chase and Montgomery County community with local-first delivery.",
    icon: "map",
  },
  {
    title: "Compliance-First",
    body:
      "Operated to the highest Maryland MCA standards — age verification, traceability, and responsible use guidance.",
    icon: "badge",
  },
  {
    title: "Human Guidance",
    body:
      "No rushed transactions. Our customer care team takes the time to match you with the right product and dose.",
    icon: "heart",
  },
];
